import getValueByDotNotation from '../../../helpers/getValueByDotNotation';
import getFieldPermission from './getFieldPermission';

const addFormSchemaEssentials = ({
  schema,
  permissions,
  initialValues,
  permittedByDefault = false,
}) => {
  if (!Array.isArray(schema)) return schema;

  const newSchema = [];
  schema.forEach(field => {
    const newField = { ...field };

    newField.initialValue = getValueByDotNotation(initialValues, field?.name);

    const derivedPermission = getFieldPermission({
      field: newField,
      permissions,
      permittedByDefault,
    });

    if (derivedPermission === 'NO_PERMISSION') {
      return;
    }

    newField.permission = derivedPermission;

    if (Array.isArray(field.children)) {
      newField.children = addFormSchemaEssentials({
        schema: field.children,
        permissions,
        initialValues,
        permittedByDefault,
      });
    }

    if (newField?.children) {
      if (Array.isArray(newField.children) && newField.children.length > 0) {
        newSchema.push(newField);
      }
    } else {
      newSchema.push(newField);
    }
  });

  return newSchema;
};

export default addFormSchemaEssentials;
